var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import { GLASS_BREAKAGE_ROOM_DAMAGES_INSTALLATION_DATE_ANSWERS, GLASS_BREAKAGE_TRAD_KEYS, } from '@declaration/constants/glassBreakageDamageConstants';
import { GLASS_BREAKAGE_ROOM_DAMAGES_INSTALLATION_DATE_CHOICES } from '@shared/constants/glassBreakageDamageConstants';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
const claim = namespace('claim');
const qualification = namespace('qualification');
const settings = namespace('settings');
let GlassBreakageRoomDamagesInstallationDateQuestion = class GlassBreakageRoomDamagesInstallationDateQuestion extends QuestionComponent {
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    get dateThreshold() {
        return this.setting('bdgRoomDamagesInstallationDateLimit');
    }
    get panelTitle() {
        return this.$tc(GLASS_BREAKAGE_TRAD_KEYS['room-damages-installation-date-panel-title'], this.dateThreshold, {
            count: this.dateThreshold,
        });
    }
    get sidebarTitle() {
        const key = GLASS_BREAKAGE_TRAD_KEYS['room-damages-installation-date-question-sidebar_title'];
        return key && this.$te(key)
            ? this.$tc(key, this.dateThreshold, { count: this.dateThreshold })
            : this.panelTitle;
    }
    get choices() {
        return GLASS_BREAKAGE_ROOM_DAMAGES_INSTALLATION_DATE_CHOICES;
    }
    get selectedValue() {
        return this.qualification.roomDamagesInstallationDate;
    }
    get answer() {
        if (this.selectedValue === null) {
            return null;
        }
        return this.$tc(GLASS_BREAKAGE_ROOM_DAMAGES_INSTALLATION_DATE_ANSWERS[this.selectedValue], this.dateThreshold, { count: this.dateThreshold });
    }
    get hideHelpLink() {
        return insurerHasFeature(InsurerFeatureFlag.HideHelpLink, this.claimTypeTrigram);
    }
    get showHelpLink() {
        var _a, _b, _c, _d;
        if (this.hideHelpLink &&
            ((_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.roomDamagesInstallationDate) === null || _d === void 0 ? void 0 : _d.showHelpLink) === false) {
            return false;
        }
        return true;
    }
    async onUpdate(roomDamagesInstallationDate) {
        await this.updateAndSaveGlassBreakageDamageQualification({
            qualificationPayload: { roomDamagesInstallationDate },
            step: this.step,
        });
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], GlassBreakageRoomDamagesInstallationDateQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    claim.State('claimTypeTrigram')
], GlassBreakageRoomDamagesInstallationDateQuestion.prototype, "claimTypeTrigram", void 0);
__decorate([
    qualification.State('qualification')
], GlassBreakageRoomDamagesInstallationDateQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateQualification')
], GlassBreakageRoomDamagesInstallationDateQuestion.prototype, "updateGlassBreakageDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], GlassBreakageRoomDamagesInstallationDateQuestion.prototype, "updateAndSaveGlassBreakageDamageQualification", void 0);
__decorate([
    settings.Getter('setting')
], GlassBreakageRoomDamagesInstallationDateQuestion.prototype, "setting", void 0);
GlassBreakageRoomDamagesInstallationDateQuestion = __decorate([
    Component({
        components: { RadioPrimaryButton, QuestionPanel },
        props: QuestionProps,
    })
], GlassBreakageRoomDamagesInstallationDateQuestion);
export default GlassBreakageRoomDamagesInstallationDateQuestion;
